export const INTERNAL_SIGNER_PRIVATE_KEY =
  'd7b1b5e4f9aef07a59caf7bd2699b20499ff8024435f23abad8466689a4374ca'

export const NFT_STORAGE_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDVBRTdmRTcxNUM1MTliOWUxM2I5NGYwN0VCOWIzRkU3OTg1ZDkxYWIiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY2ODQxOTU4MzQ1NywibmFtZSI6Ik5GVEJsb2Nrc0RlbW8ifQ.g6d6rUjs2_zBNzzIFjxBfSSnvErRJau13WTs7HFi024'
